import type { Connector } from '@particle-network/connector-core';
import { walletConfigKeys } from '../config/walletKeys';

export const filterConnectors = (connectors: readonly Connector[]) => {
  return (
    connectors
      // remove duplicate ids
      .filter(
        (connector, index, self) =>
          self.findIndex((c) => c.id === connector.id && c.chainType === connector.chainType) === index
      )
      // remove wallet when eip-6963 provider discovery
      .filter((connector, index, self) => {
        if (connector.chainType === 'solana') {
          // solana not support eip-6963.
          return true;
        }

        const isMipd = connector.id.includes('.');
        if (isMipd) {
          return true;
        }

        const groupId = walletConfigKeys.find(
          (id) =>
            id
              .split(',')
              .map((i) => i.trim())
              .indexOf(connector.id) !== -1
        );

        if (groupId && groupId.includes(',')) {
          const mipdIds = groupId
            .split(',')
            .map((id) => id.trim())
            .filter((id) => id.includes('.'));

          const hasMipd = self.find((c) => mipdIds.includes(c.id));
          return Boolean(!hasMipd);
        }

        return true;
      })
  );
};
